import { LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

const component: LayoutComponent = {
  variant: "layout",
  data: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [1, 10],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data:
                    "Second order image sources for S<sub>2</sub> are created by</br>mirroring S<sub>2</sub> on each wall except for wall 2.",
                  formatter: "html",
                  scrollbars: false,
                  styles: {
                    textAlign: "center",
                    fontSize: "12px",
                  },
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/03/08/principle/second-order-3.svg`,
                },
              },
            },
          },
        ],
      ],
    },
  },
};

export default component;
